import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=d1042796&scoped=true&"
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"
import style0 from "./carousel.vue?vue&type=style&index=0&id=d1042796&prod&lang=css&"
import style1 from "./carousel.vue?vue&type=style&index=1&id=d1042796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1042796",
  null
  
)

export default component.exports